import React, { useState } from "react";
import "./Calculator.css";
import { Button, Typography } from "@mui/material";
import LoanDetails from "./LoanDetails/LoanDetails";

const Calculator = () => {
  // States
  const [consolidationLoanAmt, setConsolidationLoanAmt] = useState(null);
  const [newMonthlyPayment, setNewMonthlyPayment] = useState(null);
  const [monthlySavings, setMonthlySavings] = useState(null);

  const handleCalculatorData = (data) => {
    setConsolidationLoanAmt(data.loanBalance);
    setNewMonthlyPayment(data.roundedPayment);
    setMonthlySavings(data.savings);
  };

  return (
    <>
      <div
        id="calculator--box"
        className="calculator_box d-flex flex-column flex-md-row align-items-md-start gap-4 w-100"
      >
        <aside id="loan_details">
          <LoanDetails onCheck={handleCalculatorData} />
        </aside>
        <section id="loan_estimate" className="">
          <div className="loan_estimate__container rounded">
            <div className="p-3">
              <div className="calculator_box w-100  gap-3 mt-3">
                <div
                  id="pl_monthly-payment"
                  className="d-flex flex-column text-wrap align-items-start justify-content-start"
                >
                  <Typography
                    sx={{
                      fontSize: "18px",
                      // color: "#623174",
                      color: "#59266D",
                      letterSpacing: "normal",
                      fontFamily: "'Archivo', sans-serif",
                      textAlign: "start",
                    }}
                    className="mt-1"
                  >
                    Your Monthly Savings Would Be:
                  </Typography>
                  <p
                    className={
                      `text-start m-0 text-break archivo ` +
                      (monthlySavings &&
                      parseFloat(monthlySavings.replace(/[^0-9.-]/g, "")) < 0
                        ? "pl_negative-monthly_savings"
                        : "pl_monthly_savings")
                    }
                  >
                    {monthlySavings !== null &&
                    parseFloat(monthlySavings.replace(/[^0-9.-]/g, "")) <= 0
                      ? "Based on the input, you currently have no savings."
                      : monthlySavings !== null
                      ? monthlySavings
                      : "N/A"}
                  </p>
                </div>
                <div className="totaling">
                  <div className="">
                    <div className="total__labels d-flex justify-content-between align-items-start">
                      <p className="totals text-break archivo m-0">
                        Consolidation <br />
                        loan amount:
                      </p>
                      <p className="amount text-break archivo m-0">
                        {consolidationLoanAmt}
                      </p>
                    </div>
                    <div className="total__labels d-flex justify-content-between align-items-start">
                      <p className="totals text-break archivo m-0">
                        New Monthly <br />
                        Payment:
                      </p>
                      <p
                        className={
                          `text-start m-0 text-break archivo ` +
                          (monthlySavings &&
                          parseFloat(monthlySavings.replace(/[^0-9.-]/g, "")) <
                            0
                            ? "negative-amount"
                            : "amount")
                        }
                      >
                        {newMonthlyPayment}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className=" text-center mt-5">
                <Button
                  variant="contained"
                  sx={{
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontFamily: "'Archivo', sans-serif",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    window.location.href = "https://minemi.ai";
                  }}
                >
                  Find Your Best Term
                </Button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Calculator;
